//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { IService } from 'src/app/shared/interfaces/service/service';
import { editService, editServiceSuccess, loadService, loadServiceSuccess, saveService, saveServiceSuccess } from './service.actions';


export interface IServiceState {
  lista: IService[];
  currentServiceId: any;
  isLoading: boolean;
  isLoadingCreate: boolean;
  isUpdated: boolean;
  type: string | null;
  action: string;
}

const initialState: IServiceState = {
  lista: [],
  currentServiceId: null,
  isLoading: false,
  isLoadingCreate: false,
  isUpdated: false,
  type: null,
  action: "get"
};

export const serviceReducer = createReducer(
  initialState,
  on(loadService, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(loadServiceSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false,
  })),
  on(saveService, (state) => ({
    ...state,
    isLoadingCreate: true,
    type: "loading",
    action: "save",
  })),
  on(saveServiceSuccess, (state, { service }) => ({
    ...state,
    isLoadingCreate: false,
    type: "success",
    action: "save",
    lista: [...state.lista, service],
  })),
  on(editService, (state) => ({
    ...state,
    isLoadingCreate: true,
    type: "loading",
    action: "edit",
  })),
  on(editServiceSuccess, (state, { service }) => ({
    ...state,
    isLoadingCreate: false,
    isUpdated: true,
    type: "success",
    action: "edit",
    lista: [...state.lista, service],
  }))
);
//colocar como parametro o serviceReducer lá no app.module
//agora criamos o selector em um novo arquivo
